module.exports = __webpack_public_path__ + "img/il_Onboarding_Programs.8efeecb9.svg";